import { forwardRef, useContext, useState } from 'react';
import { translateX } from 'utils/helpers';
import { Modal, Tabs } from 'antd';
import { useSelector } from 'react-redux';
import { ModuleContext } from 'components/jarvisly-module/ModuleContext';
import JarvislyEntitiesParametersRequiredFields from 'components/jarvisly-components/forms/modals/JarvislyParameters/JarvislyEntitiesParametersRequiredFields';
import { JarvislyFormProvider } from 'components/jarvisly-components/others/FormComponents';
import BusinessAreaModal from 'components/jarvisly-components/forms/modals/JarvislyParameters/BusinessAreaParameters/BusinessAreaModal';
import BusinessAreaTab from 'components/jarvisly-components/forms/modals/JarvislyParameters/BusinessAreaParameters/BusinessAreaTab';
import OriginTab from './Origin/OriginTab';
import OriginModal from './Origin/OriginModal';
import { ParametersContext } from 'components/jarvisly-module/ParametersProvider';
import BoardTab from './Board/BoardTab';
import PipelineTab from './Pipeline/PipelineTab';
import BoardModal from './Board/BoardModal';
import PipelineModal from './Pipeline/PipelineModal';
import TemperatureModal from './Temperature/TemperatureModal';
import TemperatureTab from './Temperature/TemperatureTab';

// COMPONENT *******************************************************************
// *****************************************************************************
const ModalComponent = forwardRef((props, ref) => {
  // providers context ---------------------------------------------------------
  const { refreshParameters } = useContext(ModuleContext);
  const { moduleType } = useSelector(s => s.moduleSlice);

  // props deconstruction ------------------------------------------------------
  const {
    showParametersModal,
    setShowParametersModal,
    selectedRecord,
    setSelectedRecord,
    isUpdated,
    setIsUpdated,
  } = props;

  // local variables I ---------------------------------------------------------
  const { parameters } = useSelector(s => s.moduleSlice);

  // component states ----------------------------------------------------------
  const [tabKey, setTabKey] = useState('formSettings');

  // local variables II --------------------------------------------------------

  // hooks ---------------------------------------------------------------------

  // METHODS -------------------------------------------------------------------
  const onClose = () => {
    setShowParametersModal(false);
  };

  function onTabClick(key) {
    setTabKey(key);

    switch (key) {
      // case 'configurations':
      //   configurationTabRef?.current?.getFirstFocus();
      //   break;

      // case 'RequiredFields':
      //   requiredFieldsTabRef?.current?.getFirstFocus();
      //   break;

      default:
        break;
    }
  }

  // local variables III --------------------------------------------------------
  const childProps = {
    ...props,
    isDisabled: false,
    isUpdated,

    parameters,
    setIsUpdated,
    selectedRecord,
    setSelectedRecord,
  };

  const tabItems = buildTabItems();

  // UI COMPONENT --------------------------------------------------------------
  return (
    <>
      <Modal
        title={translateX('parameters')}
        destroyOnHidden={true}
        open={showParametersModal}
        width={640}
        onCancel={onClose}
        okText={translateX('close')}
        cancelButtonProps={{ style: { display: 'none' } }}
        onOk={onClose}
        getContainer={false}
        okType={'default'}
        afterClose={() => {
          if (isUpdated) {
            if (moduleType === 'document') refreshParameters(true);
            setIsUpdated(false);
          }
        }}
      >
        <Tabs onChange={onTabClick} items={tabItems} activeKey={tabKey} />
      </Modal>
    </>
  );

  // INTERNAL FUNCTIONS ========================================================
  // ===========================================================================
  function buildTabItems() {
    return [
      {
        label: translateX('form'),
        key: 'formSettings',
        hide: false,
        children: (
          <JarvislyEntitiesParametersRequiredFields
            {...childProps}
            moduleName="crm"
          />
        ),
      },
      {
        label: translateX('area_activy'),
        key: 'businessArea',
        hide: false,
        children: <BusinessAreaTab {...childProps} />,
      },
      {
        label: translateX('origin'),
        key: 'origin',
        hide: false,
        children: <OriginTab {...childProps} />,
      },
      {
        label: translateX('temperature'),
        key: 'temperature',
        hide: false,
        children: <TemperatureTab {...childProps} />,
      },
      {
        label: translateX('board'),
        key: 'board',
        hide: false,
        children: <BoardTab {...childProps} />,
      },
      {
        label: translateX('pipeline'),
        key: 'pipeline',
        hide: false,
        children: <PipelineTab {...childProps} />,
      },
    ];
  }
});

// MAIN COMPONENT **************************************************************
// *****************************************************************************
const CrmParametersModal = props => {
  // providers context ---------------------------------------------------------
  const {
    showBusinessAreaModal,
    setShowBusinessAreaModal,
    showOriginModal,
    setShowOriginModal,
    showPipelineModal,
    setShowPipelineModal,
    showBoardModal,
    setShowBoardModal,
    showTemperatureModal,
    setShowTemperatureModal,
    selectedRecord,
    setSelectedRecord,
  } = useContext(ParametersContext);

  // props deconstruction ------------------------------------------------------

  // local variables I ---------------------------------------------------------

  // component states ----------------------------------------------------------
  const [isUpdated, setIsUpdated] = useState(false);

  // local variables II --------------------------------------------------------

  // hooks ---------------------------------------------------------------------

  // methods -------------------------------------------------------------------

  // variables III -------------------------------------------------------------
  const childProps = {
    ...props,
    setShowBusinessAreaModal,
    showBusinessAreaModal,
    showOriginModal,
    setShowOriginModal,
    showPipelineModal,
    setShowPipelineModal,
    showBoardModal,
    setShowBoardModal,
    showTemperatureModal,
    setShowTemperatureModal,
    selectedRecord,
    setSelectedRecord,
    isUpdated,
    setIsUpdated,
  };

  // UI COMPONENT --------------------------------------------------------------
  return (
    <>
      <JarvislyFormProvider
        document={document}
        // onConfirm={onConfirm}
        // onValuesChange={(v, allValues) => setFormData({ ...allValues })}
      >
        <ModalComponent {...childProps} />
      </JarvislyFormProvider>

      {/* AREA ACTIVITY MODAL WRAPPER */}
      <BusinessAreaModal {...childProps} />
      {/* AREA ACTIVITY MODAL WRAPPER */}

      {/* ORIGIN MODAL WRAPPER */}
      <OriginModal {...childProps} />
      {/* ORIGIN MODAL WRAPPER */}

      {/* BOARD MODAL WRAPPER */}
      <BoardModal {...childProps} />
      {/* BOARD MODAL WRAPPER */}

      {/* PIPELINE MODAL WRAPPER */}
      <PipelineModal {...childProps} />
      {/* PIPELINE MODAL WRAPPER */}

      {/* TEMPERATURE MODAL WRAPPER */}
      <TemperatureModal {...childProps} />
      {/* TEMPERATURE MODAL WRAPPER */}
    </>
  );
};

export default CrmParametersModal;
